/*
* Lazysizes.
* */
import 'lazysizes';
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";

//console.log('Go Wombat Go!');

var $ = jQuery.noConflict ();

jQuery (document).ready (function (){
    const menu = $('.page-header');

    // Menu
    $(".page-header__button-menu").on("click", function () {
        $(this).toggleClass("is-active");
        menu.toggleClass("is-active");
        $('body').toggleClass("is-hidden");

        if ($(window).width() <= 767){
            //$('main').slideToggle( "200", function() {});
        }
    });


    // Language toggle
    const lang = $('html')[0].lang;
    $('.page-header__language-button').removeClass('is-active');
    if (lang === "de-DE") {
        $('.page-header__language-button').eq(1).addClass('is-active');
    }
    if (lang === "en-US") {
        $('.page-header__language-button').eq(0).addClass('is-active');
    }

    // Header Theme
    if ($(".single-post").length > 0 ||
        $(".category").length > 0 ||
        $(".block-article-content.page-text").length > 0 ||
        $(".page-404").length > 0){
        menu.addClass('page-header--dark');
    }


    // Recent Post Menu Link
    if ($(".col-recent-post").length > 0){
        const link = $(".col-recent-post").data('recent');
        //$(".col-recent-post .sub-menu a").prop('href',link);
    }

    if ($("#new-header").length > 0){
        const postlink = $(".col-lastpost").data('lastpost');
        $(".last-blog-post a").prop('href',postlink);
    }

    // Contact
    $('.page-header__controls .fz-button-rounded').on('click', function(e){
        e.preventDefault();
        if ($('.block-contact-footer').length) {
            let top = $('.block-contact-footer').offset().top - 90;

            if ($('.block-hero--homepage').length) {
                top = $('.block-contact-footer').offset().top - 325;
            }

            $('html, body').animate({scrollTop: top}, 700);
        }
    });
    $('.menu-item-20').on('click', function(e){
        e.preventDefault();
        if ($('.block-contact-footer').length) {
            let top = $('.block-contact-footer').offset().top - 90;

            if ($('.block-hero--homepage').length) {
                top = $('.block-contact-footer').offset().top - 325;
            }

            $('html, body').animate({scrollTop: top}, 700);
            $('.page-header__button-menu').click();
        } else {
            window.location.href = "/kontakt";
        }
    });

    $('.menu-item-1966').on('click', function(e){
        e.preventDefault();
        if ($('.block-contact-footer').length) {
            let top = $('.block-contact-footer').offset().top - 90;

            if ($('.block-hero--homepage').length) {
                top = $('.block-contact-footer').offset().top - 325;
            }

            $('html, body').animate({scrollTop: top}, 700);
            $('.page-header__button-menu').click();
        } else {
            window.location.href = "/en/contact-us";
        }
    });

    $('.fz-button-rounded').on('click',function(e){
       if ($(this).attr('href') === '#contact') {
           e.preventDefault();

           if ($('.block-contact-footer').length) {
               let top = $('.block-contact-footer').offset().top - 90;

               if ($('.block-hero--homepage').length) {
                   top = $('.block-contact-footer').offset().top - 325;
               }

               $('html, body').animate({scrollTop: top}, 700);
           } else {
               if (lang === "de-DE") {
                   window.location.href = "/kontakt";
               }
               if (lang === "en-US") {
                   window.location.href = "/en/contact-us";
               }
           }
       }
    });

    // Anchors
    $('#menu-sub-menu-2 li ul a').on('click', function(e){
        if ($(this).attr('href').includes('#')){
            e.preventDefault();
            const anchor = $(this).attr('href');
            window.location = domainHome + "/services/" + anchor;
        }
    });

    $('#menu-sub-menu-3 li ul a').on('click', function(e){
        if ($(this).attr('href').includes('#')){
            e.preventDefault();
            const anchor = $(this).attr('href');
            window.location = domainHome + "/it-sustainability/" + anchor;
        }
    });

    // Mobile vieport height
    let vh = window.innerHeight * 0.01;
    $(window).on('resize', function() {
        //vh = window.innerHeight * 0.01;
        //document.documentElement.style.setProperty('--vh', `${vh}px`);
    });
    document.documentElement.style.setProperty('--vh', `${vh}px`);


    if ($('.block-jobs-cta').length) {
        $('main').css('z-index','4');
    }

    if ($('html').is(':lang(en-US)')) {
        $('.page-header__button-contact').html('Contact us');
        $('.menu-item.menu-item-type-post_type.menu-item-object-page.menu-item-722').remove();



        if ($('.fz-background-fixed').length) {
            $(window).on('scroll', function() {
                if ($('.fz-background-fixed').hasClass('is-active')) {
                    $('.block-contact-footer').addClass('green-label');
                } else {
                    $('.block-contact-footer').removeClass('green-label');
                }
            });
        }

        $('.menu-item-1608 > a').text('Sustainability');
        $('.sub-menu .menu-item-1608 > a').text('IT & Sustainability');
        $('#menu-item-1666 > a').text('Company');
        $('.menu-item-1666 > a').text('Company');
        $('.sub-menu .menu-item-1666 > a').text('About us');

        // Footer
        $('#menu-item-1951 > a').text('Company').attr('href','');

        // Calculator info
        $('.block-calculator-info__buttons-wrapper .fz-button-rounded').text('Read more');
    }

    $('.wpml-ls-item .wpml-ls-link span').each(function() {
        if ($(this).text() === "English") {
            $(this).text("EN");
        }
        if ($(this).text() === "German") {
            $(this).text("DE");
        }
    });
    setTimeout(function(){
        $('.page-header__language-button').each( function(e) {
            const index = $(this).index();

            if (index === 0) {
                $(this).attr('href', $('.wpml-ls-item-en a').attr('href'));
                //console.log($('.wpml-ls-item-en a').attr('href'));

                if ($('html').is(':lang(de-DE)')) {
                    const url      = window.location.href;
                    if (url.indexOf("it-consulting") >= 0) {
                        $(this).attr('href', window.location.origin + "/en/it-consulting");
                    }
                }
            }
            if (index === 2) {
                $(this).attr('href', $('.wpml-ls-item-de a').attr('href'));
                //console.log($('.wpml-ls-item-de a').attr('href'));

                if ($('html').is(':lang(en-US)')) {
                    const url      = window.location.href;
                    if (url.indexOf("/en/it-consulting") >= 0) {
                        $(this).attr('href',window.location.origin + "/it-consulting");
                    }
                }
            }
        });
    },100);

    $('.wpcf7-drag-n-drop-file').on('change', function() {
        //if (10485760)
        //console.log('This file size is: ' + this.files[0].size / 1024 / 1024 + "MiB");
        //console.log('This file size is: ' + this.files[0].size);
    });

});

var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone|IEMobile|Opera Mini/i.test(navigator.userAgent);
if (isMobile) {
    document.body.setAttribute('data-mobile','true');
} else {
    document.body.setAttribute('data-mobile','false');
}

if (window.document.documentMode) {
    // IE
    document.body.setAttribute('data-ie','true');
}

if (navigator.userAgent.indexOf("Edge/") > -1){
    // Edge Legacy
    document.body.setAttribute('data-ie','true');
}

window.onerror = function(msg, url, linenumber) {
    //alert('Error message: '+msg+'\nURL: '+url+'\nLine Number: '+linenumber);
    return true;
}

// Instagram plugin text truncate and link button
/*

$( ".sbi_item" ).each(function( index ) {
    const item = $(this);
    const caption = $('.sbi_caption', item);
    if (caption.text().length > 300) {
        const stringStart = caption.html().substring(0, 300);
        const stringEnd = caption.html().substring(300, caption.html().length);

        caption.empty();
        caption.append(stringStart);
        caption.append('<span class="stringToShow" style="display: none;">'+ stringEnd +'</span>');
        caption.append('<span class="buttonShowString" style="color: #35ED54; cursor: pointer;"> ...</span>');

        $('.buttonShowString', item).on('click', function() {
            $('.stringToShow', item).slideToggle( "200" );
        });
    }
});

$( ".sbi_item" ).each(function( index ) {
    const url = $('.sbi_photo', $(this)).attr('href');
    $(this).append('<div class="sb_link_button_wrapper"><a href=" ' + url +' " target="_blank" class="fz-button-rounded fz-button-rounded--tab"><span>Post ansehen</span></a></div>');
});

*/
